/**
 * Ações do menu de contexto da nota fiscal de saída.
 * Enum numérico e tipado para evitar magic string no roteamento das ações da listagem.
 */
export enum AcaoNotaFiscalSaidaEnum {
  EditarNotaFiscal = 1,
  AlterarTags = 2,
  DownloadEspelho = 3,
  VerHistorico = 4,
  ClonarNota = 5,
  ExcluirNota = 6,
  Transmitir = 7,
  LancarFinanceiro = 8,
  ExcluirFinanceiro = 9,
  VisualizarNotaFiscal = 10,
}
